import React, { useState, useEffect, useRef } from "react";
import { Tooltips } from '../../ui/components';
import { filterRegExp } from '../../shared/utils/filter';
import styles from './Filter.less';
export default function Filter({ show, initial, onChange, onClose }) {
    const [value, setValue] = useState();
    const input = useRef(null);
    const [placeholder, setPlaceholder] = useState('');
    const [error, setError] = useState(false);
    useEffect(() => {
        setValue({
            text: initial?.text ?? '',
            matchCase: initial?.matchCase ?? false,
            wholeWord: initial?.wholeWord ?? false,
            useRe: initial?.useRe ?? false,
            folders: initial?.folders ?? false,
            invert: initial?.invert ?? false,
            hidden: initial?.hidden ?? false,
            temporary: initial?.temporary ?? false,
            uncommited: initial?.uncommited ?? false,
            ignored: initial?.ignored ?? false
        });
    }, [initial]);
    useEffect(() => {
        if (show) {
            input.current?.focus();
            input.current?.select();
        }
    }, [show]);
    useEffect(() => {
        setPlaceholder(value?.useRe ?
            'Filter with JavaScript RegExp, e.g. \\.(png|jpe?g|gif)$ or image\\d{1,2}\\..*' :
            'Filter with wildcards * and ?, e.g. *.png or image-?.*');
    }, [value]);
    const update = (settings) => {
        const newValue = { ...value, ...settings };
        setValue(newValue);
        input.current?.focus();
        if (newValue.text.length) {
            const re = filterRegExp(newValue);
            setError(!re);
        }
        else {
            setError(false);
        }
        onChange(newValue);
    };
    return show && value
        ? React.createElement("div", { className: styles.root },
            React.createElement("div", { "data-error": error },
                React.createElement("i", { className: 'icon' }, "filter_alt"),
                React.createElement(Tooltips, null,
                    React.createElement("div", { className: styles.filter },
                        React.createElement("div", { className: styles.name },
                            React.createElement("input", { ref: input, value: value.text, placeholder: placeholder, onChange: e => update({ text: e.target.value }), onKeyDown: ({ key }) => key == 'Escape' && onClose(), autoComplete: "off" }),
                            React.createElement("button", { "data-on": value.matchCase, "data-tooltip": "Match Case", onClick: () => update({ matchCase: !value.matchCase }) },
                                React.createElement("i", { className: "icon" }, "match_case")),
                            React.createElement("button", { "data-on": value.wholeWord, "data-tooltip": "Match Whole Word", onClick: () => update({ wholeWord: !value.wholeWord }) },
                                React.createElement("i", { className: "icon" }, "match_word")),
                            React.createElement("button", { "data-on": value.useRe, "data-tooltip": "Use JavaScript Regular Expression", onClick: () => update({ useRe: !value.useRe }) },
                                React.createElement("i", { className: "icon" }, "regular_expression")),
                            React.createElement("button", { "data-on": value.folders, "data-tooltip": "Include Folders", onClick: () => update({ folders: !value.folders }) },
                                React.createElement("i", { className: "icon" }, "folder")),
                            React.createElement("button", { "data-on": value.invert, "data-tooltip": "Invert (Exclude Matched)", onClick: () => update({ invert: !value.invert }) },
                                React.createElement("i", { className: "icon" }, "block"))),
                        React.createElement("div", { className: styles.other },
                            React.createElement("i", { className: "icon" }, "visibility_off"),
                            React.createElement("button", { "data-tooltip": "Exclude filenames beginning with .", "data-on": value.hidden, onClick: () => update({ hidden: !value.hidden }) }, ".hidden"),
                            React.createElement("button", { "data-tooltip": "Exclude temporary, backup, lock, and swap files", "data-on": value.temporary, onClick: () => update({ temporary: !value.temporary }) }, "Temporary"),
                            React.createElement("div", { className: styles.git },
                                React.createElement("i", { className: "icon" }, "graph_1"),
                                React.createElement("button", { className: "changed", "data-on": value.uncommited, "data-tooltip": "Only Git Uncommitted", onClick: () => update({ uncommited: !value.uncommited }) }, "Uncommitted"),
                                React.createElement("button", { className: "ignored", "data-on": value.ignored, "data-tooltip": "Exclude Files in .gitignore", onClick: () => update({ ignored: !value.ignored }) },
                                    React.createElement("i", { className: "icon" }, "visibility_off"),
                                    " Ignored")))))),
            React.createElement("button", { onClick: e => onClose() }, "\u2715"))
        : React.createElement(React.Fragment, null);
}
